import { useState, useEffect } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/refuge", label: "Le refuge" },
  { to: "/experiences", label: "Expériences" },
  { to: "/avis", label: "Avis" },
  { to: "/tarifs", label: "Tarifs" },
  { to: "/bon-cadeau", label: "Bon cadeau" },
  { to: "/reserver", label: "Réserver" },
];

export default function InternalNav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 32);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header
      data-testid="internal-nav"
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-500"
      style={{
        backgroundColor: scrolled || open ? "rgba(250, 244, 236, 0.92)" : "transparent",
        backdropFilter: scrolled || open ? "blur(18px) saturate(140%)" : "none",
        WebkitBackdropFilter: scrolled || open ? "blur(18px) saturate(140%)" : "none",
        borderBottom: scrolled ? "1px solid var(--cr-line)" : "1px solid transparent",
      }}
    >
      <nav className="max-w-6xl mx-auto flex items-center justify-between px-6 md:px-8 py-4 md:py-5">
        <Link to="/accueil" data-testid="internal-logo" className="group inline-flex flex-col leading-none">
          <span className="font-heading text-xl md:text-2xl font-light" style={{ color: "var(--cr-ruby)" }}>
            Curieux <span className="italic">Refuge</span>
          </span>
        </Link>

        <ul className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <li key={l.to}>
              <NavLink
                to={l.to}
                data-testid={`internal-nav-${l.to.slice(1) || "home"}`}
                className="font-body text-[12px] tracking-[0.06em] transition-colors duration-300"
                style={({ isActive }) => ({
                  color: isActive ? "var(--cr-ruby)" : "var(--cr-ink)",
                  fontWeight: isActive ? 600 : 400,
                })}
              >
                {l.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <button
          data-testid="internal-nav-toggle"
          className="lg:hidden p-2 -mr-2"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={20} color="var(--cr-ink)" /> : <Menu size={20} color="var(--cr-ink)" />}
        </button>
      </nav>

      <div
        className="lg:hidden overflow-hidden transition-all duration-500"
        style={{ maxHeight: open ? "560px" : "0px", opacity: open ? 1 : 0 }}
      >
        <ul className="flex flex-col gap-1 px-6 pb-8 pt-1">
          {links.map((l) => (
            <li key={l.to} style={{ borderBottom: "1px solid var(--cr-line)" }}>
              <NavLink
                to={l.to}
                data-testid={`internal-mobile-nav-${l.to.slice(1)}`}
                className="font-heading text-xl py-3.5 block"
                style={({ isActive }) => ({
                  color: isActive ? "var(--cr-ruby)" : "var(--cr-ink)",
                  fontStyle: isActive ? "italic" : "normal",
                })}
              >
                {l.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </header>
  );
}
